/*

Poornima      09/19/2022 2701306337 Fixed GAL-127,132,73,60,104 bugs
Ashraf        09/23/2022 2701306337 fixed validation messages in record format
Sohel         10/06/2022 2701306337 Record Format ->File Type and Record Format System Notes Payload Changes
Rohini         10/06/2022 2701306337 Record Format ->added classnamed and worked on the buttons design
akhila         10/27/2022 2701306337  record format UX Changes
*/

import {
  Typography,
  Button,
  TextField,
  FormHelperText,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Tooltip,
} from '@material-ui/core';
import React, {useEffect, useState, useContext} from 'react';
import DialogBox from '../../../../components/DialogBox';
import * as Yup from 'yup';
import FieldSearch from './RecordFormatFieldSearch/index';
import {useDispatch, useSelector} from 'react-redux';
import {makeStyles} from '@material-ui/core/styles';
import {Formik} from 'formik';
import {
  postRecordFormat,
  ResetMessage as resetMessage,
  ResetStatus as resetStatus,
  resetRecordFormatData,
  getDropDownData,
  ResetAddRecord as resetAddRecord,
  resetOverrideStatus,
  fetchAllCodeAndDescription,
} from '../../../../redux/reducers/BRE/AddRecordFormat';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import {ExpandMore} from '@material-ui/icons';
import PageLoader from '../../../../components/PageLoader';
import {ErrorSnackbar, SuccessSnackbar} from '../../../../components/CustomSnackBar';
import {getFields} from './RecordFormatFieldSearch/RecordFormatFieldSearchTable';
import RecordFormatSystemNotes from './RecordFormatSystemNotes';
import AppContext from '../../../../components/contextProvider/AppContextProvider/AppContext';
import {ThemeContext} from '../../../../themes/ThemeProvider';
import FieldTable from './FieldTable';
import OverrideRule from '../../../../components/OverrideRule';
import {getOptions} from '../../../../util/GetDropDownOptions';
import {FILE_TYPE} from '../../../../constants/Lookup';
import {ArrowBack} from '@material-ui/icons';
import GuiAutoComplete from '../../../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../../../components/FormComponents/GuiTextField';

const useStyles = makeStyles((theme) => ({
  root: {
    'width': '100%',
    'margin': '10px 0 0',
    '& .MuiAccordionDetails-root': {
      display: 'block',
      whiteSpace: 'nowrap',
      padding: '10px',
    },
  },
  heading: {
    fontSize: theme.typography.pxToRem(16),
    fontWeight: 600,
    flexBasis: '50%',
    flexShrink: 0,
  },
  detailsText: {
    backgroundColor: '#FFF',
    padding: 10,
    boxShadow:
      '0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)',
  },
  detailsCard: {
    padding: 10,
    borderRadius: '0px 0px 8px 8px',
    backgroundColor: '#fbfbfb',
  },

  cardStyles: {
    whiteSpace: 'nowrap',
    padding: '0 15px',
  },
  labelName: {
    '& .MuiOutlinedInput-input': {
      fontSize: '13px',
    },
  },
  inputLabel: {
    '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
      fontWeight: '600',
    },
  },
  selectGender: {
    fontSize: '13px',
  },
  selectLabel: {
    fontWeight: '600 !important',
  },
  datePicker: {
    '& .MuiIconButton-root': {
      'padding': '0px !important',
      ' & .MuiSvgIcon-root': {
        fontSize: '1.3rem',
      },
    },
    '& .MuiOutlinedInput-input': {
      fontSize: '13px',
    },
    '& .MuiOutlinedInput-adornedEnd': {
      paddingRight: '6px',
    },
  },
  textField: {
    '& .MuiOutlinedInput-adornedEnd': {
      paddingRight: '40px !important',
    },
  },
  popper: {
    zIndex: '9 !important',
  },
}));

const AddRecordFormat = ({
  setRecordFormatCode,
  recordFormatCode,
  setValue,
  setTabValue,
  fieldListId,
  setFieldListId,
  isCopyIcon,
  roleDataFormat,
  notesEnable,
  rowSelected,
}) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [searchData, setSearchData] = useState([]);
  const [dialogState, setDialogState] = useState(false);
  const {
    isLoading,
    successMsg,
    errorMsg,
    addRecordFormatStatus,
    recordFormatData,
    dropDownData,
    addRecordStatus,
    addRecordData,
    userMetrix,
    allCodeAndDescriptions,
  } = useSelector(({addRecordFormat}) => addRecordFormat);
  const {reportMasterId} = useContext(AppContext);
  const [selectedRows, setSelectedRows] = useState(
    recordFormatData?.members?.length > 0 && recordFormatData?.frameWorkType === 'RecordFormat' ?
      recordFormatData.members :
      [],
  );
  const [overRiding, setOverRiding] = useState({});
  const [expanded, setExpanded] = useState();
  const [deletedRules, setDeletedRules] = useState([]);
  const [codeEntered, setCodeEntered] = useState(false);

  const handleAccordionChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };
  useEffect(() => {
    dispatch(getDropDownData());
    dispatch(fetchAllCodeAndDescription());
  }, []);

  useEffect(() => () => dispatch(resetRecordFormatData()), []);
  useEffect(() => {
    if (addRecordStatus === 200 && userMetrix === 'Yes') {
      setDialogState(true);
      setTimeout(() => {
        dispatch(resetAddRecord());
      }, 2500);
    }
  }, [userMetrix, addRecordStatus]);
  useEffect(() => {
    if (addRecordFormatStatus === 200 || successMsg) {
      setTimeout(() => {
        dispatch(resetMessage());
        setValue(0);
      }, 2000);
      const initialState = {
        code: '',
        description: '',
        fileType: {},
        fixedLength: 'none',
        seperator: 'none',
      };
      setInputFieldValues(initialState);
      setSelectedRows([]);
      dispatch(resetStatus());
      if (reportMasterId !== '') {
        setTabValue(2);
      }
    }
  }, [addRecordFormatStatus, successMsg]);

  const initialState = {
    code: '',
    description: '',
    fileType: {},
    fixedLength: 'none',
    seperator: 'none',
    filterGroup: '',
  };
  const [inputFieldValues, setInputFieldValues] = useState(initialState);
  const [reset, setReset] = useState(false);

  useEffect(() => {
    setFieldListId(recordFormatData?.fieldList);
    if (
      recordFormatData['members']?.length > 0 &&
      recordFormatData?.frameWorkType === 'RecordFormat'
    ) {
      const initialState = {
        code: recordFormatData.code || '',
        description: recordFormatData.description || '',
        fileType:
          {
            value: recordFormatData?.type?.toUpperCase(),
          } || 'none',
        fixedLength:
          recordFormatData.fixedLength === 'yes' ?
            'Y' :
            recordFormatData.fixedLength === 'no' ?
              'N' :
              'none' || 'none',
        seperator: recordFormatData.seperator || 'none',
      };
      recordFormatData['members']?.forEach((r) => {
        initialState['fieldLength' + r.fieldCode] = r.fieldLength || '';
        initialState['fieldHeader' + r.fieldCode] = r.fieldHeader;
        initialState['format' + r.fieldCode] = r.format || '';
        initialState['printTotals' + r.fieldCode] = r.printTotals || '';
      });
      setInputFieldValues(initialState);
      const selectedMembers = recordFormatData['members']?.map((member) => {
        return {
          ...member,
          globalField: member?.fieldCode || '',
          code: member?.fieldCode,
          ...getFields(member),
          tableData: {checked: true, id: member.fieldCode},
        };
      });

      recordFormatData?.frameWorkType === 'RecordFormat' ?
        setSelectedRows(selectedMembers) :
        setSelectedRows([]);
    }
  }, [recordFormatData, reset]);
  const checkCodeExist = (value) => {
    if (allCodeAndDescriptions && allCodeAndDescriptions?.length > 0 && value) {
      const ar = [];
      allCodeAndDescriptions.filter((i) => {
        if (i?.recordFormatCode?.toLowerCase()?.trim() === value?.toLowerCase()?.trim()) {
          ar.push(i);
        }
      });
      return ar.length > 0;
    } else {
      return false;
    }
  };
  const shapes = {};
  selectedRows?.forEach((r, i) => {
    shapes['fieldLength' + r.fieldCode] = Yup.string().when('fixedLength', {
      is: (val) => val !== 'N',
      then: Yup.string().required('Field length is required'),
      otherwise: Yup.string(),
    });
    shapes['format' + r.fieldCode] = Yup.string();
    shapes['printTotals' + r.fieldCode] = Yup.string();
  });
  const validationSchema = Yup.object().shape({
    ...shapes,
    fixedLength: Yup.string()
      .notOneOf(['none'], 'Fixed length is required')
      .required('Fixed length is required'),
    fileType: Yup.mixed().test('fileType', 'File type is required', (value) => {
      if (!value?.value) {
        return false;
      } else {
        return true;
      }
    }),
    code: !rowSelected ?
      Yup.string()
        .matches(
          /^[a-zA-Z0-9@]+$/,
          'Record Format Code cannot contain white space/special characters',
        )
        .test('code', 'Record format already exist', (value) => !checkCodeExist(value))
        .required('Record format code is required') :
      Yup.string()
        .required('Record format code is required')
        .matches(
          /^[a-zA-Z0-9@]+$/,
          'Record Format Code cannot contain white Space/special characters',
        ),
    seperator: Yup.string().when('fixedLength', {
      is: (val) => val === 'N',
      then: Yup.string()
        .notOneOf(['none'], 'Seperator is required')
        .required('Separator is required'),
    }),
  });
  const handleClose = () => {
    setOpen(false);
  };
  const handleDialogState = () => {
    setDialogState(false);
    dispatch(resetOverrideStatus());
  };
  const classes1 = useStyles();
  const initialVal = {
    code: isCopyIcon && !codeEntered ? '' : inputFieldValues.code,
    description: inputFieldValues.description,
    fileType: inputFieldValues.fileType,
    fixedLength: inputFieldValues.fixedLength,
    seperator: inputFieldValues.seperator,
  };
  selectedRows?.forEach((r, i) => {
    initialVal['fieldLength' + r.fieldCode] = inputFieldValues['fieldLength' + r.fieldCode];
    initialVal['format' + r.fieldCode] = inputFieldValues['format' + r.fieldCode];
    if (
      inputFieldValues['fieldHeader' + r.fieldCode] !== null &&
      inputFieldValues['fieldHeader' + r.fieldCode] !== ''
    ) {
      initialVal['fieldHeader' + r.fieldCode] =
        inputFieldValues['fieldHeader' + r.fieldCode] || r.description;
    }
    initialVal['printTotals' + r.fieldCode] = inputFieldValues['printTotals' + r.fieldCode];
  });
  const onSubmit = (data, {resetForm}) => {
    const count = [];
    const fieldsList = selectedRows.map((r, i) => {
      if (r?.fieldType === 'Global Field') {
        count.push(r);
      }
      const field = {};
      field['fieldCode'] = r.fieldCode;
      if (data['fieldLength' + r.fieldCode]) {
        field['fieldLength'] = data['fieldLength' + r.fieldCode];
      }
      field['sequence'] = i + 1;
      field['format'] = data['format' + r.fieldCode];
      field['fieldHeader'] = data['fieldHeader' + r.fieldCode];
      field['printTotals'] = data['printTotals' + r.fieldCode] ?
        data['printTotals' + r.fieldCode] :
        '';
      field['memberId'] = !isCopyIcon ? r.memberId : undefined;
      field['fieldType'] = r?.fieldType?.toUpperCase();
      field['dataType'] = r?.dataType ? r?.dataType : '';
      field['description'] = r.description;
      field['fieldListCode'] = r?.fieldListCode;
      return field;
    });
    const passValues = {
      code: data.code.toUpperCase(),
      deletedId: deletedRules ? deletedRules : [],
      description: data.description,
      members: fieldsList,
      fixedLength: data.fixedLength === 'Y' ? 'yes' : 'no',
      seperator: data.seperator || '',
      type: data.fileType.value,
      recordFormatId: (!isCopyIcon && recordFormatData['recordFormatId']) || '0',
      filtergroupid: '',
      frameWorkType: 'RecordFormat',
      filterGroup: '',
      fieldList: count?.length === 0 ? '' : fieldListId ? fieldListId : '',
      override: 'No',
    };
    setOverRiding(passValues);
    dispatch(postRecordFormat(passValues));
  };
  return (
    <>
      <Formik
        onSubmit={(values, props) => onSubmit(values, props)}
        initialValues={initialVal}
        validationSchema={validationSchema}
        enableReinitialize
        validateOnChange={false}
      >
        {(props) => {
          const {
            values,
            handleChange,
            handleBlur,
            setFieldValue,
            touched,
            errors,
            handleSubmit,
            handleReset,
            resetForm,
          } = props;
          return (
            <div className={`${classes.tabCardStyles} mb-0`}>
              <div className="button-table-spacing-mb justify-content-start">
                <Button
                  variant="outlined"
                  type="button"
                  className={`search-btn mx-1`}
                  onClick={() => {
                    setValue(0);
                  }}
                >
                  <ArrowBack className="mr-2" />
                  Search Record Format
                </Button>
              </div>
              <form autoComplete="off" noValidate onSubmit={handleSubmit} onReset={handleReset}>
                <div className="form-row global-field-textfields">
                  <div className="col-sm-6 col-md-4 form-group">
                    <TextField
                      className={` ${classes.labelName} ${classes.inputLabel}`}
                      placeholder="Enter Record Format Code"
                      margin="dense"
                      name="code"
                      variant="outlined"
                      disabled={!isCopyIcon ? Boolean(recordFormatData['code']) : false}
                      value={values?.code?.toUpperCase()}
                      onChange={(e) => {
                        setFieldValue('code', e.target.value);
                        setInputFieldValues({...inputFieldValues, code: e.target.value});
                        setCodeEntered(true);
                      }}
                      onBlur={handleBlur}
                      label={`Record Format Code`}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      required
                      fullWidth
                      error={touched.code && errors.code}
                    />
                    <FormHelperText style={{color: 'red'}} variant="outlined">
                      {touched.code && errors.code && errors.code}
                    </FormHelperText>
                  </div>
                  <div className="col-sm-6 col-md-4 form-group">
                    <TextField
                      className={` ${classes.labelName} ${classes.inputLabel}`}
                      placeholder="Enter Record Format Description"
                      margin="dense"
                      name="description"
                      variant="outlined"
                      value={values.description}
                      onChange={(e) => {
                        setFieldValue('description', e.target.value);
                        setInputFieldValues({...inputFieldValues, description: e.target.value});
                      }}
                      label="Record Format Description"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      fullWidth
                      error={errors.description}
                    />
                    <FormHelperText variant="outlined">
                      {errors && errors.description}
                    </FormHelperText>
                  </div>
                  <div
                    className={`col-sm-6 col-md-4 col-xl-2 form-group ${classes.selectdropdown}`}
                  >
                    <GuiAutoComplete
                      classes={{
                        option: classes.option,
                      }}
                      name="fileType"
                      id="fileType"
                      size="small"
                      value={values.fileType}
                      error={errors.fileType}
                      options={getOptions(FILE_TYPE, dropDownData)}
                      getOptionLabel={(option) => (option?.value ? option?.value : '')}
                      onChange={(e, value) => {
                        handleChange(e);
                        setInputFieldValues({...inputFieldValues, fileType: value});
                      }}
                      renderInput={(params) => (
                        <div className="select-field">
                          <GuiTextField
                            className={` ${classes.labelName} ${classes.selectLabel}`}
                            {...params}
                            variant="outlined"
                            margin="dense"
                            required
                            error={errors.fileType}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            label="File Type"
                            placeholder="Select File Type"
                          />
                        </div>
                      )}
                    />
                    <FormHelperText>
                      {touched.fileType && errors.fileType && errors.fileType}
                    </FormHelperText>
                  </div>
                  <div
                    className={`col-sm-6 col-md-4 col-xl-2 form-group ${classes.selectdropdown}`}
                  >
                    <FormControl
                      required
                      error={touched.fixedLength && errors.fixedLength}
                      margin="dense"
                      variant="outlined"
                      fullWidth
                    >
                      <InputLabel>Fixed Length</InputLabel>
                      <Select
                        fullWidth
                        name="type"
                        className="select-gender"
                        value={values.fixedLength}
                        onChange={(e) => {
                          setFieldValue('fixedLength', e.target.value);
                          setInputFieldValues({...inputFieldValues, fixedLength: e.target.value});
                        }}
                        label="Fixed Length"
                      >
                        <MenuItem value="none" key="none" disabled>
                          <span className="defaultSelected">Select Fixed Length</span>
                        </MenuItem>
                        <MenuItem value={'Y'} key={'Y'}>
                          Yes
                        </MenuItem>
                        <MenuItem value={'N'} key={'N'}>
                          No
                        </MenuItem>
                      </Select>
                    </FormControl>
                    <FormHelperText>
                      {touched.fixedLength && errors.fixedLength && errors.fixedLength}
                    </FormHelperText>
                  </div>
                  <div
                    className={`col-sm-6 col-md-4 col-xl-2 form-group ${classes.selectdropdown}`}
                  >
                    <FormControl
                      required={values.fixedLength === 'N'}
                      margin="dense"
                      variant="outlined"
                      fullWidth
                    >
                      <InputLabel>Separator</InputLabel>
                      <Select
                        fullWidth
                        name="type"
                        value={values.seperator}
                        onChange={(e) => {
                          setFieldValue('seperator', e.target.value);
                          setInputFieldValues({...inputFieldValues, seperator: e.target.value});
                        }}
                        label="Separator"
                      >
                        <MenuItem value="none" key="none" disabled>
                          <span className="defaultSelected">Select Seperator</span>
                        </MenuItem>
                        {dropDownData?.FIELD_SEPERATOR &&
                          dropDownData?.FIELD_SEPERATOR.map((sep) => (
                            <MenuItem value={sep.value} key={sep.key}>
                              {sep.value}
                            </MenuItem>
                          ))}
                      </Select>
                    </FormControl>
                    <FormHelperText>
                      {touched.seperator && errors.seperator && errors.seperator}
                    </FormHelperText>
                  </div>
                </div>
                <div className={` ${classes.cardBordernoneStyles} mb-0 border-rounded`}>
                  <div className="table-header">
                    <Typography variant="h4" className={classes.heading}>
                      Fields
                    </Typography>
                    <Button
                      variant="outlined"
                      className={`search-btn`}
                      onClick={() => setOpen(true)}
                    >
                      Map Variables
                    </Button>
                  </div>
                  <FieldTable
                    errors={errors}
                    touched={touched}
                    values={values}
                    setSelectedRows={setSelectedRows}
                    recordFormatCode={recordFormatCode}
                    selectedRows={selectedRows}
                    setFieldValue={setFieldValue}
                    inputFieldValues={inputFieldValues}
                    setInputFieldValues={setInputFieldValues}
                    handleChange={handleChange}
                    setDeletedRules={setDeletedRules}
                    deletedRules={deletedRules}
                  />
                </div>
                <div className="row justify-content-center mt-3">
                  <Button
                    type="button"
                    className={`reset-btn mx-1 ${classes.buttonRoot}`}
                    onClick={() => {
                      if (!recordFormatCode) {
                        setInputFieldValues(initialState);
                        resetForm(initialVal);
                        setSelectedRows([]);
                      } else {
                        setReset(!reset);
                        setDeletedRules([]);
                      }
                    }}
                  >
                    Cancel
                  </Button>
                  {(Object.keys(recordFormatData).length > 0 ?
                    roleDataFormat?.edit :
                    roleDataFormat?.add) &&
                  selectedRows &&
                  selectedRows.length > 0 ? (
                      <Button
                        type="submit"
                        variant="outlined"
                        className={`search-btn mx-1 ${classes.buttonRoot}`}
                        color="primary"
                      >
                      Save
                      </Button>
                    ) : (
                      <Tooltip title="Please add atleast one field to continue">
                        <span>
                          <Button
                            type="submit"
                            variant="outlined"
                            className={`search-btn mx-1 ${classes.buttonRoot}`}
                            color="primary"
                            disabled
                          >
                          Save
                          </Button>
                        </span>
                      </Tooltip>
                    )}
                </div>
                <DialogBox
                  open={open}
                  dialogClose={handleClose}
                  title="Map Variables"
                  maxWidth="lg"
                >
                  <FieldSearch
                    setSearchData={setSearchData}
                    selectedRows={selectedRows}
                    setSelectedRows={setSelectedRows}
                    handleClose={handleClose}
                    inputFieldValues={inputFieldValues}
                    setInputFieldValues={setInputFieldValues}
                    searchData={searchData}
                    fieldListId={fieldListId}
                    deletedRules={deletedRules}
                    setDeletedRules={setDeletedRules}
                    setFieldListId={setFieldListId}
                  />
                </DialogBox>
              </form>

              <OverrideRule
                dialogTitle="Override Record Format"
                dialogOpen={dialogState}
                dialogClose={handleDialogState}
                title="This Record Format has been used in the following frameworks."
                data={addRecordData}
                handleOverrideClose={handleDialogState}
                handleOverrideSubmit={() => {
                  dispatch(postRecordFormat({...overRiding, override: 'Yes'}));
                  handleDialogState();
                }}
              />

              {recordFormatData?.recordFormatId &&
                recordFormatData?.frameWorkType === 'RecordFormat' &&
                !isCopyIcon && (
                <div className={classes1.root}>
                  <Accordion
                    elevation={0}
                    className="accordion-styling"
                    expanded={expanded === 'panel1'}
                    onChange={handleAccordionChange('panel1')}
                  >
                    <AccordionSummary
                      expandIcon={<ExpandMore />}
                      aria-controls="panel1d-content"
                      id="panel1d-header"
                    >
                      <Typography className={classes1.heading}>
                          Report Record Format Notes
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails className={classes1.detailsCard}>
                      <RecordFormatSystemNotes
                        setRecordFormatCode={setRecordFormatCode}
                        recordFormatCode={recordFormatCode}
                      />
                    </AccordionDetails>
                  </Accordion>
                </div>
              )}
            </div>
          );
        }}
      </Formik>
      {isLoading && <PageLoader />}
      {errorMsg && <ErrorSnackbar errorMsg={errorMsg} />}
      {successMsg && <SuccessSnackbar successMsg={successMsg} />}
    </>
  );
};

export default AddRecordFormat;
